export const setLocation = href => window.location.href = href;